app.directive('personalDetails', [function () {
    return {
        templateUrl: 'templates/directives/personalDetails.html'
    }
}]);